module.exports = __webpack_public_path__ + "fonts/Inter-100-latin-ext27.ad4eb06.woff2";